$(function () {

  var carTypeRadio = $('.listing-car-type-radio');
  var hiddenFieldsForMoto = $('.hidden-for-moto');

  function hideOrShowMotoFields(carType, fields) {
    if (carType === 'moto') {
      fields.slideUp();
    } else {
      fields.slideDown();
    }
  }

  carTypeRadio.on('change', function () {
    var carType = $(this).find('input:checked').val();

    hideOrShowMotoFields(carType, hiddenFieldsForMoto);
  });

  hideOrShowMotoFields(carTypeRadio.find('input:checked').val(), hiddenFieldsForMoto);

});


// WEBPACK FOOTER //
// ./app/webpacker/src/js/unused_moto_fields_remover.js